import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import {
  getAllfund,
  getAllBanks,
  getAllPaymentMethods,
} from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import { Grid } from "@material-ui/core";
import ConfirmDialogAddNumberDistrbutor from "../global/ConfirmDialogAddNumberDistrbutor";
import ConfirmDialogListNumberDistrbutor from "../global/ConfirmDialogListNumberDistrbutor";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import packageJson from "../../../../package.json";
import ConfirmDialog from "../global/ConfirmDialogCon";
import { getAllServices } from "../../../services/Services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function CreateTransactions() {
  const [fund, setfund] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [fundoption, setFundoption] = useState([]);
  const distrbutor_mobile= localStorage.getItem('distrbutor_mobile')

  const [mobile_number, setMobile_number] = useState(distrbutor_mobile);

  const [priceamount, setPriceAmount] = useState();
  const [fundpost, setFundpost] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const [Banks, setBanks] = useState([]);
  const [stringData, setStringData] = useState("");
  const [stringDataloading, setStringDataloading] = useState(false);
  const [ErrorPaymentMethod, setErrorPaymentMethod] = useState(false);
  const [ErrorBank, setErrorBank] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data2, setdata2] = useState("");
  const [message, setmessage] = useState("");
  const [open, setOpen] = useState(false);
  const [ServicesData, setServices] = useState([]);
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog1, setConfirmDialog1] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog2, setConfirmDialog2] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  useEffect(() => {}, [stringDataloading]);

  useEffect(() => {
    setIsLoading(true);
    getAllfund()
      .then((res) => {
        setfund(res.data);
        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });
    getAllBanks().then((res) => {
      setBanks(res);
    });
    getAllPaymentMethods()
      .then((res) => {
        setPaymentMethod(res.data);
        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });
      getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);
  const initialFValues = {
    mobile_number: "",
    amount: "",
    payment_method: "",
    bank: "",
    number_transfer: "",
    image: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (fieldValues.mobile_number === "") {
        temp.mobile_number = "هذا الحقل مطلوب";
      } else if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else {
        temp.mobile_number = "";
      }
    }
    if (fundoption === "BankTransfer") {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "هذا الحقل مطلوب";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "هذا الحقل مطلوب";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "هذا الحقل مطلوب";
        } else {
          temp.image = "";
        }
      }
    } else {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "";
        } else {
          temp.image = "";
        }
      }
    }
    if ("amount" in fieldValues)
      temp.amount = fieldValues.amount ? "" : " الكمية مطلوبة";
    if ("payment_method" in fieldValues)
      temp.payment_method = fieldValues.payment_method ? "" : "الحقل مطلوب";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (
        fieldValues.mobile_number !== "" &&
        !/^[0-9]+$/.test(fieldValues.mobile_number)
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (
        fieldValues.mobile_number !== "" &&
        fieldValues.mobile_number.length !== 10
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else {
        temp.mobile_number = "";
      }
    }
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);

  const handleSubmit = () => {
    // e.preventDefault();
    if (validate()) {
      setLoading(true);
      if (fundoption === "BankTransfer") {
        const bodyFormData = new FormData();
        bodyFormData.append("mobile_number", mobile_number);
        bodyFormData.append("amount", fundpost);
        bodyFormData.append("payment_method", fundoption);
        bodyFormData.append("bank", loginInput.bank);
        bodyFormData.append("number_transfer", loginInput.number_transfer);
        bodyFormData.append("image", image);
        axios
          .post(`${BaseUrl}/api/TransferLiretna`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status == true) {
              setLoading(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                localStorage.setItem("distrbutor_mobile", '');
                window.location.reload();
              });
            } else if (res.data.status === false) {
              setLoading(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                localStorage.setItem("distrbutor_mobile", '');
                window.location.reload();
              });
              setLogin({ ...loginInput, error_list: res.data.message });
            }
          });
      }
      if (fundoption === "E_payment") {
        const data = {
          mobile_number: mobile_number,
          amount: fundpost,
        };
        axios
          .post(`${BaseUrl}/api/addPaymentFatoraTrans`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status == true) {
              setLoading(false);

              const url = res.data.data.url;
              sweetalert("سيتم توجيهك الى نافذة الدفع الالكتروني", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then((res) => {
                window.open(url, "_blank");
                localStorage.setItem("distrbutor_mobile", '');
                window.location.reload();
              });
            } else if (res.data.status === false) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                localStorage.setItem("distrbutor_mobile", '');
                window.location.reload();
              });
              setLogin({ ...loginInput, error_list: res.data.message });
            }
            setLoading(false);
          });
      } else {
        const data = {
          mobile_number: mobile_number,
          amount: fundpost,
          payment_method: fundoption,
        };
        axios
          .post(`${BaseUrl}/api/TransferLiretna`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status == true) {
              localStorage.setItem("distrbutor_mobile", '');

              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            } else if (res.data.status === false) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
              setLogin({ ...loginInput, error_list: res.data.message });
            }
            setLoading(false);
          });
      }
    }
  };

  const handleChange = (e, fieldName) => {
    const value = e.target.value;

    if (fieldName === "mobile_number") {
      setMobile_number(value);
      setLogin({ ...loginInput, mobile_number: e.target.value });
    }
     else if (fieldName === "amount") {
      setFundpost(value);
      setLogin({ ...loginInput, amount: e.target.value });

    }
     else if (fieldName === "payment_method") {
      setFundoption(e.target.value);
    setLogin({ ...loginInput, payment_method: e.target.value });
      if (mobile_number !== "" && fundpost.length !== 0) {
        const data = {
          amount: fundpost,
          mobile_number: mobile_number,
          payment_method: e.target.value,
        };

        axios
          .post(`${BaseUrl}/api/getPriceBuyAndSell`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === false) {
              // Handle string data
              setStringData("رقم الموبايل غير موجود");
              setStringDataloading(true);
              setPriceAmount(null); // Clear any existing array data
            } else if (res.data.status === true) {
              // Handle object data
              setStringDataloading(false);
              setTimeout(() => {
                setPriceAmount(res.data.data);
              }, 1000);
              setStringData(null); // Clear any existing string data
            }
          })
          .catch((error) => {
            console.error("Error in API call:", error);
          });
      }
    }
  };
  const handlefile = (e) => {
    setLogin({ ...loginInput, [e.target.name]: e.target.files[0] });
    setImage(e.target.files[0]);
  };
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);

  const handelPayment = (e) => {
    setFundoption(e.target.value);
    setLogin({ ...loginInput, payment_method: e.target.value });
  };
  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  function handleListNumber() {
  
    axios
      .get(`${BaseUrl}/api/getMyDistributor`, {
        withCredentials: true,
      })

      .then((res) => {
        if (res.data.status === true) {

          setdata2(res.data.data);
          setmessage(res.data.msg);
     
        }
      });
    setConfirmDialog1({
      isOpen: true,
      title: "سجل الارقام",
      onConfirm: () => {},
    });
  }

  useEffect(() => {
    setMobile_number(distrbutor_mobile)
    setLogin({ ...loginInput,mobile_number:distrbutor_mobile})
  },[distrbutor_mobile])
  useEffect(() => {
    const distributor_mobile = localStorage.getItem('distributor_mobile');
    if(distributor_mobile) {
      setMobile_number(distributor_mobile);
      setLogin({ ...loginInput, mobile_number: distributor_mobile });
      // Clear the local storage after setting the state
      localStorage.removeItem('distributor_mobile');
    } else {
      setMobile_number('');
      setLogin({ ...loginInput, mobile_number: '' });
    }
  }, []);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className="main-div">
      <h3 className="titlepage">تحويل رصيد ليرتنا كاش</h3>
      {
        ServicesData[0]?.name == "TransferLiretna"  &&  ServicesData[0]?.is_active == 1? (
      <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item md={10} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="mobile_number"
                variant="outlined"
                fullWidth
                onChange={(e) => handleChange(e, "mobile_number")}
                value={mobile_number}
                className="form-control"
                error={errors.mobile_number}
              />
              {stringDataloading && (
                <div style={{ color: "red" }}>{stringData}</div>
              )}{" "}
            </Grid>
            <Grid item md={2} xs={12}>
              <AddCircleIcon
                style={{ cursor: "pointer" }}
                className="svgadd"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    subTitle: "إضافة رقم الموبايل إلى سجل الارقام",
                    onConfirm: () => {},
                  });
                }}
              />
              <ConfirmDialogAddNumberDistrbutor
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                phone={mobile_number}
              />
              <AssignmentTurnedInIcon
                style={{ cursor: "pointer" }}
                className="svgadd1"
                onClick={() => {
                  handleListNumber()
                }}
              />
              <ConfirmDialogListNumberDistrbutor
                confirmDialog={confirmDialog1}
                setConfirmDialog={setConfirmDialog1}
                phone={mobile_number}
                data2={data2}
              />
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="القيمة"
              name="amount"
              variant="outlined"
              fullWidth
              value={fundpost}
              onChange={(e) => handleChange(e, "amount")}
              className="form-control"
              type="number"
              error={errors.amount}
            />
          </Grid>
     
          <Grid item md={12} xs={12}>
            <label>طريقة الدفع</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="payment_method"
                onChange={(e) => handleChange(e, "payment_method")}
              >
                <option selected disabled>
                  اختر طريقة الدفع
                </option>
                {paymentMethod.map((opts, i) => (
                  <option key={opts} value={opts.name}>
                    {opts.name_ar}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.payment_method == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.payment_method}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          {fundoption === "BankTransfer" ? (
            <>
              <Grid item md={6} xs={12}>
                <label>البنك</label>
                <div class="select">
                  <select
                    className="form-control"
                    class="select-text"
                    name="bank"
                    onChange={handleInputChange}
                  >
                    <option selected disabled>
                      اختر البنك
                    </option>
                    {Banks.map((opts, i) => (
                      <option key={opts.id} value={opts}>
                        {opts}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                </div>
                <div style={{ color: "red", fontSize: "10px" }}>
                  {fundoption === "BankTransfer" ? errors.bank : ""}
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <Controls.Input
                  label="رقم الحوالة"
                  name="number_transfer"
                  variant="outlined"
                  fullWidth
                  onChange={handleInputChange}
                  className="form-control"
                  error={
                    fundoption === "BankTransfer" ? errors.number_transfer : ""
                  }
                  type="number"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Controls.Input
                  label="صورة الحوالة"
                  name="image"
                  variant="outlined"
                  fullWidth
                  onChange={handlefile}
                  className="form-control"
                  error={fundoption === "BankTransfer" ? errors.image : ""}
                  type="file"
                />
              </Grid>
            </>
          ) : (
            <></>
          )}
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر الشراء"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={priceamount?.buy_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر المبيع"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={priceamount?.sell_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <>

          
            <Controls.Button
              type="submit"
              disabled={stringDataloading === true ? true : false}
              text="تحويل"
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                  }}}
              variant="contained"
              className={
                stringDataloading === true
                  ? " btn-submit-disabled"
                  : "btn-submit"
              }
            >

            </Controls.Button>
                 <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
      </>
          )}
        </Grid>
      </Grid>
      ):  ServicesData[0]?.name == "TransferLiretna" &&
        ServicesData[0]?.is_active == 0 &&
        staff_type == "Admin" &&
        mobile_number_login == "0950555563" ? (
          <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item md={10} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="mobile_number"
                variant="outlined"
                fullWidth
                onChange={(e) => handleChange(e, "mobile_number")}
                value={mobile_number}
                className="form-control"
                error={errors.mobile_number}
              />
              {stringDataloading && (
                <div style={{ color: "red" }}>{stringData}</div>
              )}{" "}
            </Grid>
            <Grid item md={2} xs={12}>
              <AddCircleIcon
                style={{ cursor: "pointer" }}
                className="svgadd"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    subTitle: "إضافة رقم الموبايل إلى سجل الارقام",
                    onConfirm: () => {},
                  });
                }}
              />
              <ConfirmDialogAddNumberDistrbutor
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                phone={mobile_number}
              />
              <AssignmentTurnedInIcon
                style={{ cursor: "pointer" }}
                className="svgadd1"
                onClick={() => {
                  handleListNumber()
                }}
              />
              <ConfirmDialogListNumberDistrbutor
                confirmDialog={confirmDialog1}
                setConfirmDialog={setConfirmDialog1}
                phone={mobile_number}
                data2={data2}
              />
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="القيمة"
              name="amount"
              variant="outlined"
              fullWidth
              value={fundpost}
              onChange={(e) => handleChange(e, "amount")}
              className="form-control"
              type="number"
              error={errors.amount}
            />
          </Grid>
     
          <Grid item md={12} xs={12}>
            <label>طريقة الدفع</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="payment_method"
                onChange={(e) => handleChange(e, "payment_method")}
              >
                <option selected disabled>
                  اختر طريقة الدفع
                </option>
                {paymentMethod.map((opts, i) => (
                  <option key={opts} value={opts.name}>
                    {opts.name_ar}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.payment_method == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.payment_method}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          {fundoption === "BankTransfer" ? (
            <>
              <Grid item md={6} xs={12}>
                <label>البنك</label>
                <div class="select">
                  <select
                    className="form-control"
                    class="select-text"
                    name="bank"
                    onChange={handleInputChange}
                  >
                    <option selected disabled>
                      اختر البنك
                    </option>
                    {Banks.map((opts, i) => (
                      <option key={opts.id} value={opts}>
                        {opts}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                </div>
                <div style={{ color: "red", fontSize: "10px" }}>
                  {fundoption === "BankTransfer" ? errors.bank : ""}
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <Controls.Input
                  label="رقم الحوالة"
                  name="number_transfer"
                  variant="outlined"
                  fullWidth
                  onChange={handleInputChange}
                  className="form-control"
                  error={
                    fundoption === "BankTransfer" ? errors.number_transfer : ""
                  }
                  type="number"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Controls.Input
                  label="صورة الحوالة"
                  name="image"
                  variant="outlined"
                  fullWidth
                  onChange={handlefile}
                  className="form-control"
                  error={fundoption === "BankTransfer" ? errors.image : ""}
                  type="file"
                />
              </Grid>
            </>
          ) : (
            <></>
          )}
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر الشراء"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={priceamount?.buy_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر المبيع"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={priceamount?.sell_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <>

          
            <Controls.Button
              type="submit"
              disabled={stringDataloading === true ? true : false}
              text="تحويل"
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                  }}}
              variant="contained"
              className={
                stringDataloading === true
                  ? " btn-submit-disabled"
                  : "btn-submit"
              }
            >

            </Controls.Button>
                 <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
      </>
          )}
        </Grid>
      </Grid>
                
      ): ServicesData[0]?.name == "TransferLiretna"  &&  ServicesData[0]?.is_active == 0?(
<div class="services-no-available">
هذه الخدمة غير متاحة
<img src="7703205.webp"/>

</div>
                ):(
                  <></>)}
    </div>
  );
}
